import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SiteLogo from "@/components/feature/SiteLogo";

const NAV_ITEMS = [
  { label: "首页", path: "/" },
  { label: "漫画分类", path: "/category" },
  { label: "搜索", path: "/search" },
  { label: "关于我们", path: "/about" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const handleSearch = (event: React.FormEvent) => {
    event.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  const isActive = (path: string) =>
    path === "/" ? location.pathname === "/" : location.pathname.startsWith(path);

  return (
    <header className="sticky top-0 z-40 bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="h-16 md:h-[72px] flex items-center justify-between gap-4">
          <SiteLogo />

          <nav className="hidden lg:flex items-center gap-1">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  isActive(item.path)
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <form onSubmit={handleSearch} className="hidden md:flex items-center relative">
              <i className="ri-search-line absolute left-3 text-foreground-400 text-base"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索漫画名 / 作者"
                className="w-44 lg:w-56 h-10 pl-9 pr-3 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
              />
            </form>

            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen(true)}
              className="lg:hidden w-10 h-10 rounded-md flex items-center justify-center text-foreground-800 hover:bg-background-100 cursor-pointer"
            >
              <i className="ri-menu-3-line text-2xl"></i>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile drawer */}
      <div
        className={`lg:hidden fixed inset-0 z-50 transition-opacity ${
          open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
      >
        <div
          className="absolute inset-0 bg-foreground-950/40"
          onClick={() => setOpen(false)}
        ></div>
        <aside
          className={`absolute top-0 right-0 h-full w-72 max-w-[80%] bg-background-50 flex flex-col transition-transform duration-300 ${
            open ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <div className="h-16 px-4 flex items-center justify-between border-b border-background-200">
            <SiteLogo />
            <button
              type="button"
              aria-label="关闭菜单"
              onClick={() => setOpen(false)}
              className="w-10 h-10 rounded-md flex items-center justify-center text-foreground-800 hover:bg-background-100 cursor-pointer"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
          </div>
          <div className="p-4 flex flex-col gap-1">
            <form onSubmit={handleSearch} className="relative mb-3">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-base"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索漫画名 / 作者"
                className="w-full h-11 pl-9 pr-3 rounded-md bg-background-100 border border-background-200 text-sm focus:outline-none focus:border-primary-400"
              />
            </form>
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-3 rounded-md text-base font-medium cursor-pointer ${
                  isActive(item.path)
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-800 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </aside>
      </div>
    </header>
  );
}